import { render, staticRenderFns } from "./memberCommunity.vue?vue&type=template&id=9ec854f2"
import script from "./memberCommunity.vue?vue&type=script&lang=js"
export * from "./memberCommunity.vue?vue&type=script&lang=js"
import style0 from "./memberCommunity.vue?vue&type=style&index=0&id=9ec854f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports